
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexHBIwYJIn0ZF55UutInzZ4GQ_CgEj2r4Gi5nrWwrh2VsMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/index.vue?macro=true";
import { default as indexo1EBMQslhvffn0Zol0RIqeOf4c6Gf__pYEQ1HIFdIYkMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/post/index.vue?macro=true";
import { default as index7VE6C8dw7_45rH7Wt9YyDfQBt4NI8BW7dzi_45oA1bi3OvoMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/post/reply/index.vue?macro=true";
import { default as postviYKNnBmExbxCiYP66NrcDiXO2TvByw0NMoQlAUhgNIMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/post.vue?macro=true";
import { default as index1ewt0L5hOaLKRVCA23Psvzhaoq0idE5HyMC8_45grkVrYMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/group/index.vue?macro=true";
import { default as indexSz6Xqw8UvTrjS4Pn_TLpEPQzS_45iB8l0_456MDxCvzThQ4Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/group/records/index.vue?macro=true";
import { default as groupKamQtyZKBG_45MUJ_TCMZSr30oW351WhdmLFktxkoWKI8Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/group.vue?macro=true";
import { default as indexlS1U5oCRUhfctOt7_45_DOmP1o_45C8q6yirphA4KV5O7HsMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/solution/index.vue?macro=true";
import { default as index04B6Alcac_IfiLGioMHDQNhHvRjExOY3EluWqxDv_45msMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/solution/reply/index.vue?macro=true";
import { default as solutionxxypgoVGzGIPHpEtyyTJpbhHZpLZjOs_45_UiXKxCRdJ8Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/solution.vue?macro=true";
import { default as index1pjs0IgqTS7freMXTMkt5wF_45GaReSSrlYNro_45e1eNvYMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/task/index.vue?macro=true";
import { default as indexqnUY2G73rEVYMLGWA0kaTshkpkqHqaAFa5B3yJHJ25IMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/contest/index.vue?macro=true";
import { default as index7rP_45ciMntfpoSzc9lXP_IP9dlpaZ9q5NUCPCOi1gdTYMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/problem/index.vue?macro=true";
import { default as homehGU6aXzNsq5Jt3npN1kgCtzc0A_FQyi0Hpsf9uZ19MMMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home.vue?macro=true";
import { default as indexhPiAcovRTDpHv4MI7VZ1JbS8prpYhcm9vQZtVKsmSYIMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/group/todo/index.vue?macro=true";
import { default as indexTRLRyygoVOBX7PKvqDpZljZApaUKGe2hJro_45_45LMyi8sMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/group/notice/index.vue?macro=true";
import { default as indexK49qgOxY6ZQtZlJhs0BZjaB3nqhDtE8VG3xFDZfhhjgMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/group/contest/index.vue?macro=true";
import { default as indexAYyLEuSSlh50djvbINfgFadItjcveKr9B45GbgWJpOwMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/group/members/index.vue?macro=true";
import { default as indexnqavyf6Ag6ruJJnwQD3UDEPqrpU86LpxbEpbSWyXAUYMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/group/problem/index.vue?macro=true";
import { default as indexLkimxKzMD_OyhT7lN6Ns94PW1m7cJWSOHiySEJwAaXIMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/group/training/index.vue?macro=true";
import { default as groupboq9S_y96vNo3oLX_45NMaA8j3jqVwRx6_45P_Kjb7E08TYMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/group.vue?macro=true";
import { default as indexMO8lCMAHnDzU7BcjoPbwP2XSgcm_45_45x6vE64tE0HCacYMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/tag/list/index.vue?macro=true";
import { default as index2CgKPjSODDVyCMTNNl7gPzl48t5BkldD390kXH0KA6YMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/tag/category/index.vue?macro=true";
import { default as tagWo_45Rp9dIDf7i1RAMERyxEYM_455u8_A_45dzHIve2jCn1FUMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/tag.vue?macro=true";
import { default as indexk6SnJl6VbN0xYGT32zuw2L6_a1TkBnf86qG575QOWOIMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/user/index.vue?macro=true";
import { default as index7k5ZZqfamBheYj68SnooQzwY2ej_45XwQFPIrnMT1FUNgMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/user/role/index.vue?macro=true";
import { default as index4kFzeBLiGlOlCoyi5UqWvr9TrstHcHcGV4jpBnuGP5AMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/user/detail/index.vue?macro=true";
import { default as indexY8M4o7Ul3g_45JqPyO0oVY39kQXx6paoc_455blEfhH9yx0Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/user/competition-award-data/index.vue?macro=true";
import { default as indexxdAbrXVylaaCHKkhRkT_PPT4TmC3VksYuZ9DuFUaU9QMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/user/competition-award-review/index.vue?macro=true";
import { default as userfew2674i0nLsq9OtW6AoTfRHOSbaiIxevDpOLs8qXZoMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/user.vue?macro=true";
import { default as hetao_45testk5OZWBKLuw5iGvelSY4OmXsXaWcjOWUw6jSu7JzI9_EMeta } from "/work/release/fe-oj-monorepo-hetao/apps/fe-oj-hetao/pages/hetao-test.vue?macro=true";
import { default as indexJT0hX1iXLw1GjRcQDDn6ng4iKYZovh77dABDFb6nIvsMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/link/index.vue?macro=true";
import { default as indexeKtWa4FtUUeafOXKXwM_bItv5eeuSkFBOl8cpIZDYKgMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/profile/index.vue?macro=true";
import { default as indexR_45ucnDc8Yrg8cnxdx7w8wP_6nN6A16v3f_45WrstpkExMMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/profile/security/index.vue?macro=true";
import { default as indexlyIIaigxSLhdGhrZAABQ1bJsSh4PGN5iTyHijG0RAGgMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/profile/preference/index.vue?macro=true";
import { default as profileWNkveByLCNMkkX2jNl4kPyXOWuZPmYCKw4l5VqgqDv4Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/profile.vue?macro=true";
import { default as indexfmzJ_45MT1Wduqi9e_7MLKXWCEMjvOb_b_AQ5HqUARI_MMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest/edit/index.vue?macro=true";
import { default as indexDAKvj2_45IL9DWCilg_r5Sk1b03n80ezFt5AJU4_sF3l8Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest/list/index.vue?macro=true";
import { default as indexlXALn0JzZ6bjtLOKRgj84sopPhaR6O8RSDFDtyofeyUMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest/view/index.vue?macro=true";
import { default as indexdvaU0EvE9kTruF8G7KyIx8W3XtfQUUWk8UYZlDmP05kMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest/score/index.vue?macro=true";
import { default as indexe2s1Il_45gJMbGFE2uggt2RHAwcVwnsoOMi4zmC_45fA8GEMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest/create/index.vue?macro=true";
import { default as indexu_xnvNbkYza1SF7_G8PPOAFpCZuZ7csn6Yqoy17W11QMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest/problem/index.vue?macro=true";
import { default as indexN0FOy2ivcbFISaDbMc0oRQkIXdNwY5JfqMuO_45kqzLL8Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest/submissions/index.vue?macro=true";
import { default as indexKQkHJfhiXKlTotOpMDkH00o_4539GMt6MzG0GNXccorBkMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest/announcement/index.vue?macro=true";
import { default as indexP8QN3q1VmAu1ihOnFHDV6mjvs_455sSyYXfCQuVZr9XM4Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest/announcement/create/index.vue?macro=true";
import { default as contestiSdXixuV0o6l6AXaFd8o9cbs5_0y7wYazoxd9SUFkPYMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest.vue?macro=true";
import { default as indexaXDxl3MWVKfpK7qWidx7gQny3rn5ZDLWut7KnoN_WgYMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem/list/index.vue?macro=true";
import { default as indexvCxQct_45tIe_45pFQH4hR48v8XBnEma7zHMY4dl4pjRdM8Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem/edit/oj/index.vue?macro=true";
import { default as index5tcjibt_QCVDhU0_45rOiIeJflQFHVJq0z5SjlG_O0SxwMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem/view/oj/index.vue?macro=true";
import { default as indexA11nrGXijCEU9_mS4Ot_45AmVpBNeXyQNghQAqsr15v1IMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem/solution/index.vue?macro=true";
import { default as index1tU38z6_45512kDwYILbloHhv3cpuA6_JpcGcZBJLpOZgMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem/create/oj/index.vue?macro=true";
import { default as indexnhASRRUAlUPxMVwbXkB93_45wwTn_45kEeYg2fbVkCE8gHQMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem/edit/objective/index.vue?macro=true";
import { default as index0_OBElyfyuYJOgjxBjUNbZZbGfsnKdp2ok090z1z8ZsMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem/view/objective/index.vue?macro=true";
import { default as indexKo0JHKTbdv4KGwOCQbsGvbKmv6D7HvSKbhjGBZ_JJyEMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem/solution/create/index.vue?macro=true";
import { default as indexQX_dMyisLRgRey8XZlhmknhjkM_451XMAgMxwU5ZJizxgMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem/create/objective/index.vue?macro=true";
import { default as problem3qPkwebc7NI_45wNRCNxi38a9DVs9G9y5sSKYptluyLZ0Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem.vue?macro=true";
import { default as indexUfpDRNUi_45czlXD8_4zqmy4C2qtrydv3XINsx2MxRWCsMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/training/edit/index.vue?macro=true";
import { default as index50NZgsP3hmzRefoeiRgv45QFj365CrZFrPKIsxIaaRYMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/training/list/index.vue?macro=true";
import { default as index0Z_B67wCR_EnBpsPLwOLhLKkLUvaja_45mJCGzR_45H5Ho0Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/training/view/index.vue?macro=true";
import { default as indexHir9LAMxlarnlD4CtwrZyXSFi_cVHwWXEgdUMrqRtL4Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/training/create/index.vue?macro=true";
import { default as indexEHq7mYEsd2m1Dhs0_45VTIysTE0Ohh62sfIis3B5Pc7zIMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/training/status/index.vue?macro=true";
import { default as indexmp_45iVsJfXo653Vk50qbeud3_9jHTLZB8IIMzS9MlkjsMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/training/problem/index.vue?macro=true";
import { default as indexan_0BLcE6jbkt91K7yWNefa7aGm3XZYBwy8IxtBF_45sEMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/training/submissions/index.vue?macro=true";
import { default as trainingwAuZPrniYYNu6HBM_45Ds_45IHdIrqOC5hSyeTker15bfMIMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/training.vue?macro=true";
import { default as indexSQWKmNfutdvo_45Ni6sEvbl7oRFGcR4PCp4DxbX0_BN6cMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/edit/index.vue?macro=true";
import { default as indexAWpd0RLmOu3_45y7bQ5Qkd_uIyZrbLI29EJrAKfT62l2AMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/list/index.vue?macro=true";
import { default as index9xZ3VG6eUPO_2IUrnJq63JM9Y7t5Bwald6_45comg2rBwMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/role/index.vue?macro=true";
import { default as indexWb2_fb20ZBIj6xcNXu8jh7RqeUID7LRN5cvtU9axT5wMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/view/index.vue?macro=true";
import { default as indexWUg4skSdFNKeIeRAFq5ive_MvmIApdwds9QAwMnQkQEMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/apply/index.vue?macro=true";
import { default as indexYywmR62ZKgVG6oRzc3godIisTFYDM8UJSuTqjKDxZYIMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/create/index.vue?macro=true";
import { default as index5P0_45HLINR_aeq3Y_45IGjZgLrkZAB2zZYmvc5GyFy4f5QMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/member/index.vue?macro=true";
import { default as indexy7SD4eIxcntWEU_455PzXq3W_zvw_45bgseiV_45N2Ac8mrNYMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/submission/index.vue?macro=true";
import { default as index_q5luKhJZJk1WlqFNrNofh6l0e38BIR_45NyGJtcet_45WwMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/announcement/index.vue?macro=true";
import { default as indexx9TNLjfusJ5AgiRlplz1nRpzhzMlLh6_45O0Xpu7Eie5UMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/announcement/create/index.vue?macro=true";
import { default as groupGvA6x1AwXyDia1y7jXbYBBzawC3NuvmKdLVuVnUodyIMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group.vue?macro=true";
import { default as indexGKmOffu0sv_4jb4miqmSwL9iOImgIXHDyLGCl8wdcusMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/index.vue?macro=true";
import { default as indexoubvzYuf3BepWRsa_REVI3DX_E_45KqeS2P_yMm_45c5n_oMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest/edit/index.vue?macro=true";
import { default as indexmW_45duvlfoBnVzTVypZkkjxP3WgMDPQZ4Co1FcALHsQoMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest/list/index.vue?macro=true";
import { default as indexT_45T3VhLVmvYAMsmnnGhwvqJ653t5NkjjzKoi6wjWE_45sMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest/view/index.vue?macro=true";
import { default as indexXKDK2ZshiBtB1YVDZ_s9Vv0CbQSbem77Ml0ip6z2z4MMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest/score/index.vue?macro=true";
import { default as indexkA80_45qf0MBpzb4leH9PvQ8egGOGEObHVvchGjkt7m7UMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest/create/index.vue?macro=true";
import { default as indexAwx_OP0BeT9dRZ1QDDyFELKkAbmCy_hDZmfcKlYIlnYMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest/problem/index.vue?macro=true";
import { default as indexPIV3PhYGQnV67tZmZI5Ou_i_fu9QF3ygp1wnhqFBy5cMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest/submissions/index.vue?macro=true";
import { default as index_9Al_45TseJQxbHOlAAk_45SRxSs8DF03tdgMMX1ODZ_LGUMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest/announcement/index.vue?macro=true";
import { default as index_10ja0fnoVu8oBX0tD53f6rPD7qqvAOsb5M0AbPcBmcMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest/announcement/create/index.vue?macro=true";
import { default as contest3gSNcrZu6_FtI_hbpAaN8vnfXzr6MCL_45S3HAbSwLSbYMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest.vue?macro=true";
import { default as indexw4KzG8S3d1fcQwvK6eua99w_45HIiA9CIRG8lw1BkcXCYMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem/list/index.vue?macro=true";
import { default as indexqMlhXvWRcIcMyC8BkMEqTN34LS_45LMB77DYbv0ALYYZYMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem/edit/oj/index.vue?macro=true";
import { default as indexLwLrlWi1hvDso14Zwn7WtLd_i_sIdd5dOMSWwXcX12IMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem/view/oj/index.vue?macro=true";
import { default as index35b9_45AzUqrP54KojpbW_mFoKIpzsbev3JHVwI1VHEQMMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem/solution/index.vue?macro=true";
import { default as indexNC_sVSyiymx3elTd31VsVHgW9eUys5owKeVMDh6ykIkMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem/create/oj/index.vue?macro=true";
import { default as indexwGjI6CGevWAnGw2KyAbOSsaH_45chRP1DkI_45D46bxB_45L8Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem/edit/objective/index.vue?macro=true";
import { default as indexeXY6pT3j_tEOSkdH4jRYouycF_45oWxTer4Ykjv7G6tzAMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem/view/objective/index.vue?macro=true";
import { default as indexk3aY5up7Z2PwWmOS5cu7QuRt9IJiunOreFrF02qTshEMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem/solution/create/index.vue?macro=true";
import { default as indexh79on8P_45SJbbmw9aJ3ITOwGKjMKkmT6gXpoCdLaMr0QMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem/create/objective/index.vue?macro=true";
import { default as problemrq2gEvoPFjeZQz8LDp9S2reac_45KqQ4UiOAJYmwKrxLEMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem.vue?macro=true";
import { default as indexu7R_456SqXNiLp8kfi9_8O9_cCFydv4mNYtJiTs1jPKdEMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/task/index.vue?macro=true";
import { default as indexEQBzZ1XFUC2xG148gXCaKXBjdeifRqwWhJB919a89p0Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/training/edit/index.vue?macro=true";
import { default as indexmGfRqhxkwVgwh6VPIM26_45oI5H6V2WIcBDcl14E80OiIMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/training/list/index.vue?macro=true";
import { default as index6tUqjx6ziYWRkaKHxvQeh0FG1EmJKqgZB5es7o6SfC8Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/training/view/index.vue?macro=true";
import { default as index98eNPjPuuVXoyDY2D_qMuOHp9uvgDtVo7pWzlLg98sAMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/training/create/index.vue?macro=true";
import { default as indexg7PYF3Wo4ObruCdVF7f5qupXEBBUDaSnoomvRaBHscsMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/training/status/index.vue?macro=true";
import { default as indexgDy1DGxHdADKrweCDBxRfVUhvLfK1H3L9Aby855WGJwMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/training/problem/index.vue?macro=true";
import { default as indexrvQifHpTdh5jfFAkK6ciN4CT3kfEGuoqJMWx7xTdzp0Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/training/submissions/index.vue?macro=true";
import { default as trainingGB199HqKoCFm7MNHBUlPiziZa56H4kpC_45tnu2_45D_PIoMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/training.vue?macro=true";
import { default as indexjS08joancDKP7rMBxV6FzdyJ6LlVTYhXY3KVTpipXdgMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/guide/index.vue?macro=true";
import { default as indexV55Ic1tLcgllQMbQl9nn7nqIanT_zi2L_45cOcHlnWJeUMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/community/post/index.vue?macro=true";
import { default as indexswMM9PiL79BlRyOF_45Mxt_ob_yfNS_RBzxX2AZCCUeVwMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/community/solution/index.vue?macro=true";
import { default as indexBRZi7YgHnyWfBPFhHIrAFTUxTs1Dk97uaoUqvgvKGy0Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/community/post/comment/index.vue?macro=true";
import { default as indexnHWKDlwNybmORqg_bRDe0QrzMuMZD1Wx3vLO0H3tNnQMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/community/problem/comment/index.vue?macro=true";
import { default as indexEEYHMbcXRB_45ZLXNatJlny9y9_450pNJ5fA5sK11V_451OZcMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/community/solution/comment/index.vue?macro=true";
import { default as indexFeg4CC2LDupC2zY6SoE98C2_uPVhGoyr3hspA8SePmsMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/community/post/applications/index.vue?macro=true";
import { default as communityC7Q_3hvGHRRWAukG1hwn9AXIAYMcMySZZ_eS8P_tOR4Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/community.vue?macro=true";
import { default as indexdSN7FnGao8wKIG5xBOqMvrS0a9bNYtYjkLh7PHLN6N4Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/warehouse/edit/index.vue?macro=true";
import { default as indexFlRwthJHTXg_4550TEzLLvG6Y_UsqTjnsy2ciEqazllRgMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/warehouse/list/index.vue?macro=true";
import { default as index1Ueu5gY5_45HnWD8S2Brd1wPKUOkg46Z98kA_45W51tBElkMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/warehouse/view/index.vue?macro=true";
import { default as index_453A47Z4_GYQYLH8WDmTQdCxCA6xVIQo8SoIc7rBAbMMMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/warehouse/create/index.vue?macro=true";
import { default as indexf1j1YfO3w5aS3xwrlZ9kKiNjdm2vHkgAI57PtNt00SsMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/warehouse/import/index.vue?macro=true";
import { default as indexMUzQH9h8x5OZKoykgKVct6PcCu_p8MRX_z3zBP0Um6EMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/warehouse/problem/index.vue?macro=true";
import { default as indexzZosiUxxSP48w7nwfYwhya3aoWHco7InxWxwrzNGYtcMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/warehouse/import/whitelist/index.vue?macro=true";
import { default as warehousemgfNhVp8LUKzwedExrkEvSv9LFK8T8KwBKyEgk_JiQMMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/warehouse.vue?macro=true";
import { default as indexhLSk3HQste3Bkr6S4Ce6rGKQ3_45zygQxb4KG8HhnR0tMMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/galaxy/index.vue?macro=true";
import { default as index_45sAoIutyVcQPLJtM1z4HO7GbF4F3Yy276htC42ROa4EMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/notice/index.vue?macro=true";
import { default as indexOaBPirKE2Z9ZpWKYmTYvfBhFXk0qpFz17i5QN3a7dwEMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/discuss/category/general/index.vue?macro=true";
import { default as indexHOr3cw3DN_45pC_4U9PJUBysVbIMYxxV7NA_b5HF_45u3Y0Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/discuss/category/academic/index.vue?macro=true";
import { default as categoryErheMEtjkJhhpqa3T7pfhc_45oF6mVmZ3wlIpO4idY6k4Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/discuss/category.vue?macro=true";
import { default as index2JhQl5mcn1zSc9YIcdCAsdnThJsXJQghgcgQWVJxxSAMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/im/student/index.vue?macro=true";
import { default as indexFCaMET_45ArM25_JKB_L5Dy_45dEji8UQfcJuTW7WpzwF18Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/im/teacher/index.vue?macro=true";
import { default as index60PZu7l7OA676uGPm5lllqZOtdkZrdSw0o4y2sQW_45xwMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/article/index.vue?macro=true";
import { default as indexDXrR_oAI47pZJrfrP_axq5iv_459mF7XYwYuuLyDLqgh0Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/contest/index.vue?macro=true";
import { default as indexNXP7cHQfmY_45SLExurIqZt7lCpqAu93L66rQEXJfNVSEMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/problem/index.vue?macro=true";
import { default as index6sADbCsWawNt5YSjo_45OctYJc6yIETpDJ6Uba_aNXyfIMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/ranking/index.vue?macro=true";
import { default as index9s91GAzGWsaVbb_mCVQxZNx3QXrPa1pN5PGEB9LjBC8Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/indexconfig/banner/index.vue?macro=true";
import { default as indexKYDWgrsaipUXHME0s8mdJD4FHWm6_45TIHBT5tSTt3aS0Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/indexconfig/article/index.vue?macro=true";
import { default as indexzVBpKWvLYNc1EPPj337ti2d0UAByJdvlVfU0H8VyYVsMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/indexconfig/contest/index.vue?macro=true";
import { default as indexBnH_dXGIzjsUqc5xFmxLA_45bdpsokhni6zLhAojzmW7wMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/indexconfig/banner/create/index.vue?macro=true";
import { default as index8AvMp3SUsATNatqJbzl6_45_ujxl_45VjiCILyINh4eEyg4Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/indexconfig/article/create/index.vue?macro=true";
import { default as indexconfig4dxWW5fmFJQ5E3suuIBGBaqwbZH4_M3ObQNorWB79IMMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/indexconfig.vue?macro=true";
import { default as indexhPSFX5dFup_aOgsdf_45JTeFFUfam7xvt_45W0QjnvUp__45cMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/backpack/index.vue?macro=true";
import { default as indexIRgrY8U41XeOx7NNCNDINXfh1xT0uqbYW0boZ85_45N_45QMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/contest/detail/index.vue?macro=true";
import { default as indexHl565v0Br7OY5s9gLrUVMBRIFZ96_SXjktr_2uolBFoMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/contest/detail/score/index.vue?macro=true";
import { default as index6eC7brBsAkNqbaG0zj6_qEiXSa9gXsGTQ_TDhb4IChoMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/contest/detail/notice/index.vue?macro=true";
import { default as indexoJr2tvToRcFdbi6JLP_8iRW2pMVfpRwq937vK9pzIBwMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/contest/detail/problem/index.vue?macro=true";
import { default as detailCOxCz6QAsFDXsH7e7MxO_lUTLQUg4il3W3Nt_KnfiDcMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/contest/detail.vue?macro=true";
import { default as index0UdhTszsQFZeIw5diKMNdZmQydIGxO3GWvG7iH9fRxkMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/training/index.vue?macro=true";
import { default as contest_45codeBPLVM_45bS5da2n_A3SgJk5z44vs6hRtbIOwQV0_yViPkMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest-code.vue?macro=true";
import { default as indexdhKtM33yOFgmi7nb9mE78bf7LpnoMrjAbEV2N9FJKZcMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/callback/crm/index.vue?macro=true";
import { default as indexkoZ3LqPdJL96yJaF3pH6fe3aMmR7p8SVQmQATq1ee6oMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/training/detail/index.vue?macro=true";
import { default as indexnT57PfIJUa2Q_csq1IY5Js_45MwSToyMkl_45acNYf69o7MMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/training/detail/problem/index.vue?macro=true";
import { default as detailVTZE9nxB2BGQEXB4jybE16yLjU6UarjXL21l5WtEk5MMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/training/detail.vue?macro=true";
import { default as indexkAQ5f4NFqqGqPRqdKLBTcKF12_yBs2ZsW49lG2bout8Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/callback/code/index.vue?macro=true";
import { default as indexnc2JPz8zy7566jbK1HL0RDKgJjrxrUloKdbg7pmoPy0Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/callback/group/index.vue?macro=true";
import { default as indexqNu9M1GInAO3lPSFK8Y9kmh0Dbt4PrMnsnCupjB7KcAMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/callback/feishu/index.vue?macro=true";
import { default as indexzcmPbuzBydW_45ZbUxiYVAoig5SZdtCwH2_455VptJI0ATsMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/callback/wechat/index.vue?macro=true";
import { default as index2pm__jmhMYbGNjxFJ6mA54GmpQkHHpi4RBPyMbJmzoYMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/announcement/index.vue?macro=true";
import { default as indexJRZwf6or81HhRkmzxpBV5lOWjlJADoEc3ZflylBle3AMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/reward/badge/index.vue?macro=true";
import { default as indexMjZbRC738C6nwn65ujThAvuNDUovsGBNLiCRpU4beG0Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/reward/avatarframe/index.vue?macro=true";
import { default as indexIFV7ban4KcND_45Pe_Y8mza9yFuKSIHz4di8jbY4n_VjQMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/reward/cursortrails/index.vue?macro=true";
import { default as index0vv7_LpfNj0wHjvnrDhYvB7Kb6mhH31CIMyrmSEuck8Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/reward/homebackground/index.vue?macro=true";
import { default as index4x6G0NcJzTSNsdHY7I34Xx9Ejbnadub1iSRrYJuL3_45cMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/reward/gradedecoration/index.vue?macro=true";
import { default as rewardY_45tctXZ5R3dYRRfy237BUW8LICaKwaeQSRr_45WotwWKAMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/reward.vue?macro=true";
import { default as indexe3T1WM4eK6EBR60vBt_M5RRt6jqIkSpxaZqGxpG5tqsMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/submission/index.vue?macro=true";
import { default as indexewpyKkyZxY_45HUptduJNiDExACFVWF6Iv0oRhZISd82IMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/entrance-exam/index.vue?macro=true";
import { default as indexQngqVS5cvtT7pCMCKNnmgDMxc_3GhUx0qcF41ymH64sMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/galaxy/report/index.vue?macro=true";
import { default as indexfh9Au3IE8gupocvdl1tpFk_CKTazC8eDfXZcBcwzjSkMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission/edit/index.vue?macro=true";
import { default as indexibGgxqYOLySj2Mqg4ZNd1B8uh_QojfXLu6bms_E1R3AMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission/view/index.vue?macro=true";
import { default as indexcvHrrvpdJdmfxqCBgFSEGSkPXTN1FGC6ZHu415j0gh0Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission/goods/index.vue?macro=true";
import { default as indexukCBgVZvMy2EyXyX2nyiodLHAazb_45UP3XYsf4mo9C38Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission/medal/index.vue?macro=true";
import { default as indexZtcCiuXGf7Ayg_7k7OxY7SkzCaucEJYMlt1ck5L0XlcMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission/battle/index.vue?macro=true";
import { default as indexcnQmFKnlIDydrnx3k5rxemt22hpHmkNWs15Wf9zdHHEMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission/create/index.vue?macro=true";
import { default as indexhfwa2BwXwWOf9aop1AbSslwO5ztiHri5fOd4UeIYN2cMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission/manual/index.vue?macro=true";
import { default as indexxFOlIfbJjHilVTc_HnXz2T3MWJFimRg8Hni3sPg5QA0Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission/normal/index.vue?macro=true";
import { default as indexAlqrjj7YYjhyIW3nc_gQSROYRFRQLBMoa_dYdqyW5TgMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission/random/index.vue?macro=true";
import { default as missionTYq1Zj0UOM8MZPcpLYTLMmczWrHWPdHNN_45GypOTYFwQMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission.vue?macro=true";
import { default as indexsHnBXb0ABWRHEvu0sV5ZIotV9Rs20NY6ZMm1ogMEwQsMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/discuss/post/edit/index.vue?macro=true";
import { default as indexNhyGVu0Pa7xnXY5Vmn9eGykYvduLqljF9cPidXj_eBIMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/article/detail/index.vue?macro=true";
import { default as indexpIZJHKnlc16_wgaCz_T_gR0GMWO9GAtif8XpjBbhjqkMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/galaxy/problem/index.vue?macro=true";
import { default as indexOLhYnoqYWGTD6hZdQTx6B4_Qd10TWXKjpSpcLJsLWaEMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/problem/detail/index.vue?macro=true";
import { default as indexgSziubV_ydjgR7Q5p64BQF2Easj05hZMZZ_45gC9VNmDAMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/clouddesktop/index.vue?macro=true";
import { default as indexyaSvIBoe842m7XweVyMh8XnmkhSqRCAIYpAfkfBsafgMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/activity/zongzi/index.vue?macro=true";
import { default as index8PP26z8HgcG08kftB0qjIbuEE_gL7t0GrbHnGRJXE58Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/discuss/post/create/index.vue?macro=true";
import { default as indexh5K8Nz87IDYEOb0EacgQaoMeV_45MFDjCEeUuZgiKoY8AMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/discuss/post/detail/index.vue?macro=true";
import { default as indexDYrXIAB_45zQ8d5LumWLHNVybFaM7MhhFcg8afXuckT1sMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/activity/lantern/index.vue?macro=true";
import { default as index0YYChBSlPa6mSPG4usayFZkFV1SfNw6_1XCDVF3jLr0Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/galaxy/milestone/index.vue?macro=true";
import { default as indexuLhNbLTMh6kCd_oKHtDrWv7diBvkqUCZj6y3u5RN4XgMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/problem/solution/index.vue?macro=true";
import { default as indexWUwzB_cIlafr_AiPOPRnOEd3MwIZYnJEv_45g9ud7AIQsMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/level/index.vue?macro=true";
import { default as index6_JwXkPQb_UAGfLQh_bg78rn9_84kHWTql_ISdAMH3MMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/activity/challenge/index.vue?macro=true";
import { default as indexHwxnDYouD2XJ2XWpQuRUltRHCJUxI60e2x5DsrK0JyoMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/problem/submit/list/index.vue?macro=true";
import { default as indexSAlNlc29pmvwrpFQbaSY3fo_lv_45jorWJD7cCyuAA9MAMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/problem/solution/edit/index.vue?macro=true";
import { default as indexGqPW5ca3lx8vKTdHpQ_45SORq0pFzrLnXtE5nPaKlO8S4Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/problem/submit/result/index.vue?macro=true";
import { default as indexlEhde16vjo08oC75eIDNTkfGkuZYdD6lnyU_45iwHVx_wMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/activity/challenge/exam/index.vue?macro=true";
import { default as indexEhn29bOtLH6rhccu28z8Q0M5bLvpXq19f9X6tX6xQ4AMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/problem/solution/create/index.vue?macro=true";
import { default as indexyeX4MQAYvdMMeonCUpUVwKjEriaRtgGiHi4Wm1p7PbsMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/problem/solution/detail/index.vue?macro=true";
import { default as indexsQNP4_45TD3MOOIr_JTZDssqC4X1OaJ7uJZQbJg3TdAkQMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/activity/simulation2025/rank/index.vue?macro=true";
import { default as indexHwbJAj_45fevpgxTQecmtfL6KZ1pqTRBnjG9CGDxod1wAMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/activity/challenge/result/index.vue?macro=true";
import { default as MilestoneWrongIX_45FWM1JnoTiQ2bjaOUlJWXPjFK_M_JAeYWuMkyC3JwMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/galaxy/milestone/MilestoneWrong.vue?macro=true";
import { default as MilestoneRecordSXb1J2ocOsGk_wJ7lgs_gpev9W8BC_uLLBMgsm2uxM8Meta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/galaxy/milestone/MilestoneRecord.vue?macro=true";
import { default as use_45galaxy_45mdown_45transformowbab_k6I2SidnD3hR0cz_zdG3CKYYHoBQYUjTzQ2XEMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/galaxy/utils/use-galaxy-mdown-transform.ts?macro=true";
import { default as ChallengeExam_46serviceurhA1PB2zmMIBRHXiowX708WOhLJV_8XZOGcdiMC1DcMeta } from "/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/activity/challenge/exam/ChallengeExam.service.ts?macro=true";
import { default as component_45stubQDP5SU1qXbGoXNgEMQHfLV3apqBHBpOREyzHGJPreUkMeta } from "/work/release/fe-oj-monorepo-hetao/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@20.19.25_db0@0.3.4_eslint@9.39.1_jiti@2.6.1__io_2i5jmtfny4kok2wdv4tm26va6q/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubQDP5SU1qXbGoXNgEMQHfLV3apqBHBpOREyzHGJPreUk } from "/work/release/fe-oj-monorepo-hetao/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@20.19.25_db0@0.3.4_eslint@9.39.1_jiti@2.6.1__io_2i5jmtfny4kok2wdv4tm26va6q/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexHBIwYJIn0ZF55UutInzZ4GQ_CgEj2r4Gi5nrWwrh2VsMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/index.vue")
  },
  {
    name: "oj_home",
    path: "/oj/home",
    meta: homehGU6aXzNsq5Jt3npN1kgCtzc0A_FQyi0Hpsf9uZ19MMMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home.vue"),
    children: [
  {
    name: postviYKNnBmExbxCiYP66NrcDiXO2TvByw0NMoQlAUhgNIMeta?.name,
    path: "post",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/post.vue"),
    children: [
  {
    name: "oj_home_post",
    path: "",
    meta: indexo1EBMQslhvffn0Zol0RIqeOf4c6Gf__pYEQ1HIFdIYkMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/post/index.vue")
  },
  {
    name: "oj_home_post_reply",
    path: "reply",
    meta: index7VE6C8dw7_45rH7Wt9YyDfQBt4NI8BW7dzi_45oA1bi3OvoMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/post/reply/index.vue")
  }
]
  },
  {
    name: groupKamQtyZKBG_45MUJ_TCMZSr30oW351WhdmLFktxkoWKI8Meta?.name,
    path: "group",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/group.vue"),
    children: [
  {
    name: "oj_home_group",
    path: "",
    meta: index1ewt0L5hOaLKRVCA23Psvzhaoq0idE5HyMC8_45grkVrYMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/group/index.vue")
  },
  {
    name: "oj_home_group_records",
    path: "records",
    meta: indexSz6Xqw8UvTrjS4Pn_TLpEPQzS_45iB8l0_456MDxCvzThQ4Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/group/records/index.vue")
  }
]
  },
  {
    name: solutionxxypgoVGzGIPHpEtyyTJpbhHZpLZjOs_45_UiXKxCRdJ8Meta?.name,
    path: "solution",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/solution.vue"),
    children: [
  {
    name: "oj_home_solution",
    path: "",
    meta: indexlS1U5oCRUhfctOt7_45_DOmP1o_45C8q6yirphA4KV5O7HsMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/solution/index.vue")
  },
  {
    name: "oj_home_solution_reply",
    path: "reply",
    meta: index04B6Alcac_IfiLGioMHDQNhHvRjExOY3EluWqxDv_45msMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/solution/reply/index.vue")
  }
]
  },
  {
    name: "oj_home_task",
    path: "task",
    meta: index1pjs0IgqTS7freMXTMkt5wF_45GaReSSrlYNro_45e1eNvYMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/task/index.vue")
  },
  {
    name: "oj_home_contest",
    path: "contest",
    meta: indexqnUY2G73rEVYMLGWA0kaTshkpkqHqaAFa5B3yJHJ25IMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/contest/index.vue")
  },
  {
    name: "oj_home_problem",
    path: "problem",
    meta: index7rP_45ciMntfpoSzc9lXP_IP9dlpaZ9q5NUCPCOi1gdTYMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/home/problem/index.vue")
  }
]
  },
  {
    name: "oj-group",
    path: "/oj/group",
    meta: groupboq9S_y96vNo3oLX_45NMaA8j3jqVwRx6_45P_Kjb7E08TYMeta || {},
    redirect: {"name":"oj_group_problem"},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/group.vue"),
    children: [
  {
    name: "oj_group_todo",
    path: "todo",
    meta: indexhPiAcovRTDpHv4MI7VZ1JbS8prpYhcm9vQZtVKsmSYIMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/group/todo/index.vue")
  },
  {
    name: "oj_group_notice",
    path: "notice",
    meta: indexTRLRyygoVOBX7PKvqDpZljZApaUKGe2hJro_45_45LMyi8sMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/group/notice/index.vue")
  },
  {
    name: "oj_group_contest",
    path: "contest",
    meta: indexK49qgOxY6ZQtZlJhs0BZjaB3nqhDtE8VG3xFDZfhhjgMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/group/contest/index.vue")
  },
  {
    name: "oj_group_members",
    path: "members",
    meta: indexAYyLEuSSlh50djvbINfgFadItjcveKr9B45GbgWJpOwMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/group/members/index.vue")
  },
  {
    name: "oj_group_problem",
    path: "problem",
    meta: indexnqavyf6Ag6ruJJnwQD3UDEPqrpU86LpxbEpbSWyXAUYMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/group/problem/index.vue")
  },
  {
    name: "oj_group_training",
    path: "training",
    meta: indexLkimxKzMD_OyhT7lN6Ns94PW1m7cJWSOHiySEJwAaXIMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/group/training/index.vue")
  }
]
  },
  {
    name: "admin-tag",
    path: "/admin/tag",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/tag.vue"),
    children: [
  {
    name: "admin_tag_list",
    path: "list",
    meta: indexMO8lCMAHnDzU7BcjoPbwP2XSgcm_45_45x6vE64tE0HCacYMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/tag/list/index.vue")
  },
  {
    name: "admin_tag_category",
    path: "category",
    meta: index2CgKPjSODDVyCMTNNl7gPzl48t5BkldD390kXH0KA6YMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/tag/category/index.vue")
  }
]
  },
  {
    name: userfew2674i0nLsq9OtW6AoTfRHOSbaiIxevDpOLs8qXZoMeta?.name,
    path: "/admin/user",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/user.vue"),
    children: [
  {
    name: "admin_user",
    path: "",
    meta: indexk6SnJl6VbN0xYGT32zuw2L6_a1TkBnf86qG575QOWOIMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/user/index.vue")
  },
  {
    name: "admin_user_role",
    path: "role",
    meta: index7k5ZZqfamBheYj68SnooQzwY2ej_45XwQFPIrnMT1FUNgMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/user/role/index.vue")
  },
  {
    name: "admin_user_detail",
    path: "detail",
    meta: index4kFzeBLiGlOlCoyi5UqWvr9TrstHcHcGV4jpBnuGP5AMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/user/detail/index.vue")
  },
  {
    name: "admin_user_competition_award_data",
    path: "competition-award-data",
    meta: indexY8M4o7Ul3g_45JqPyO0oVY39kQXx6paoc_455blEfhH9yx0Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/user/competition-award-data/index.vue")
  },
  {
    name: "admin_user_competition_award_review",
    path: "competition-award-review",
    meta: indexxdAbrXVylaaCHKkhRkT_PPT4TmC3VksYuZ9DuFUaU9QMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/user/competition-award-review/index.vue")
  }
]
  },
  {
    name: "hetao-test",
    path: "/hetao-test",
    component: () => import("/work/release/fe-oj-monorepo-hetao/apps/fe-oj-hetao/pages/hetao-test.vue")
  },
  {
    name: "link",
    path: "/link",
    meta: indexJT0hX1iXLw1GjRcQDDn6ng4iKYZovh77dABDFb6nIvsMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/link/index.vue")
  },
  {
    name: profileWNkveByLCNMkkX2jNl4kPyXOWuZPmYCKw4l5VqgqDv4Meta?.name,
    path: "/oj/profile",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/profile.vue"),
    children: [
  {
    name: "oj_profile",
    path: "",
    meta: indexeKtWa4FtUUeafOXKXwM_bItv5eeuSkFBOl8cpIZDYKgMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/profile/index.vue")
  },
  {
    name: "oj_profile_security",
    path: "security",
    meta: indexR_45ucnDc8Yrg8cnxdx7w8wP_6nN6A16v3f_45WrstpkExMMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/profile/security/index.vue")
  },
  {
    name: "oj_profile_preference",
    path: "preference",
    meta: indexlyIIaigxSLhdGhrZAABQ1bJsSh4PGN5iTyHijG0RAGgMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/profile/preference/index.vue")
  }
]
  },
  {
    name: "admin-group",
    path: "/admin/group",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group.vue"),
    children: [
  {
    name: "admin-group-contest",
    path: "contest",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest.vue"),
    children: [
  {
    name: "admin_group_contest_edit",
    path: "edit",
    meta: indexfmzJ_45MT1Wduqi9e_7MLKXWCEMjvOb_b_AQ5HqUARI_MMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest/edit/index.vue")
  },
  {
    name: "admin_group_contest_list",
    path: "list",
    meta: indexDAKvj2_45IL9DWCilg_r5Sk1b03n80ezFt5AJU4_sF3l8Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest/list/index.vue")
  },
  {
    name: "admin_group_contest_view",
    path: "view",
    meta: indexlXALn0JzZ6bjtLOKRgj84sopPhaR6O8RSDFDtyofeyUMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest/view/index.vue")
  },
  {
    name: "admin_group_contest_score",
    path: "score",
    meta: indexdvaU0EvE9kTruF8G7KyIx8W3XtfQUUWk8UYZlDmP05kMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest/score/index.vue")
  },
  {
    name: "admin_group_contest_create",
    path: "create",
    meta: indexe2s1Il_45gJMbGFE2uggt2RHAwcVwnsoOMi4zmC_45fA8GEMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest/create/index.vue")
  },
  {
    name: "admin_group_contest_problem",
    path: "problem",
    meta: indexu_xnvNbkYza1SF7_G8PPOAFpCZuZ7csn6Yqoy17W11QMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest/problem/index.vue")
  },
  {
    name: "admin_group_contest_submissions",
    path: "submissions",
    meta: indexN0FOy2ivcbFISaDbMc0oRQkIXdNwY5JfqMuO_45kqzLL8Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest/submissions/index.vue")
  },
  {
    name: "admin_group_contest_announcement",
    path: "announcement",
    meta: indexKQkHJfhiXKlTotOpMDkH00o_4539GMt6MzG0GNXccorBkMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest/announcement/index.vue")
  },
  {
    name: "admin_group_contest_announcement_create",
    path: "announcement/create",
    meta: indexP8QN3q1VmAu1ihOnFHDV6mjvs_455sSyYXfCQuVZr9XM4Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/contest/announcement/create/index.vue")
  }
]
  },
  {
    name: "admin-group-problem",
    path: "problem",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem.vue"),
    children: [
  {
    name: "admin_group_problem_list",
    path: "list",
    meta: indexaXDxl3MWVKfpK7qWidx7gQny3rn5ZDLWut7KnoN_WgYMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem/list/index.vue")
  },
  {
    name: "admin_group_problem_edit_oj",
    path: "edit/oj",
    meta: indexvCxQct_45tIe_45pFQH4hR48v8XBnEma7zHMY4dl4pjRdM8Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem/edit/oj/index.vue")
  },
  {
    name: "admin_group_problem_view_oj",
    path: "view/oj",
    meta: index5tcjibt_QCVDhU0_45rOiIeJflQFHVJq0z5SjlG_O0SxwMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem/view/oj/index.vue")
  },
  {
    name: "admin_group_problem_solution",
    path: "solution",
    meta: indexA11nrGXijCEU9_mS4Ot_45AmVpBNeXyQNghQAqsr15v1IMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem/solution/index.vue")
  },
  {
    name: "admin_group_problem_create_oj",
    path: "create/oj",
    meta: index1tU38z6_45512kDwYILbloHhv3cpuA6_JpcGcZBJLpOZgMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem/create/oj/index.vue")
  },
  {
    name: "admin_group_problem_edit_objective",
    path: "edit/objective",
    meta: indexnhASRRUAlUPxMVwbXkB93_45wwTn_45kEeYg2fbVkCE8gHQMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem/edit/objective/index.vue")
  },
  {
    name: "admin_group_problem_view_objective",
    path: "view/objective",
    meta: index0_OBElyfyuYJOgjxBjUNbZZbGfsnKdp2ok090z1z8ZsMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem/view/objective/index.vue")
  },
  {
    name: "admin_group_problem_solution_create",
    path: "solution/create",
    meta: indexKo0JHKTbdv4KGwOCQbsGvbKmv6D7HvSKbhjGBZ_JJyEMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem/solution/create/index.vue")
  },
  {
    name: "admin_group_problem_create_objective",
    path: "create/objective",
    meta: indexQX_dMyisLRgRey8XZlhmknhjkM_451XMAgMxwU5ZJizxgMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/problem/create/objective/index.vue")
  }
]
  },
  {
    name: "admin-group-training",
    path: "training",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/training.vue"),
    children: [
  {
    name: "admin_group_training_edit",
    path: "edit",
    meta: indexUfpDRNUi_45czlXD8_4zqmy4C2qtrydv3XINsx2MxRWCsMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/training/edit/index.vue")
  },
  {
    name: "admin_group_training_list",
    path: "list",
    meta: index50NZgsP3hmzRefoeiRgv45QFj365CrZFrPKIsxIaaRYMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/training/list/index.vue")
  },
  {
    name: "admin_group_training_view",
    path: "view",
    meta: index0Z_B67wCR_EnBpsPLwOLhLKkLUvaja_45mJCGzR_45H5Ho0Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/training/view/index.vue")
  },
  {
    name: "admin_group_training_create",
    path: "create",
    meta: indexHir9LAMxlarnlD4CtwrZyXSFi_cVHwWXEgdUMrqRtL4Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/training/create/index.vue")
  },
  {
    name: "admin_group_training_status",
    path: "status",
    meta: indexEHq7mYEsd2m1Dhs0_45VTIysTE0Ohh62sfIis3B5Pc7zIMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/training/status/index.vue")
  },
  {
    name: "admin_group_training_problem",
    path: "problem",
    meta: indexmp_45iVsJfXo653Vk50qbeud3_9jHTLZB8IIMzS9MlkjsMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/training/problem/index.vue")
  },
  {
    name: "admin_group_training_submissions",
    path: "submissions",
    meta: indexan_0BLcE6jbkt91K7yWNefa7aGm3XZYBwy8IxtBF_45sEMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/training/submissions/index.vue")
  }
]
  },
  {
    name: "admin_group_edit",
    path: "edit",
    meta: indexSQWKmNfutdvo_45Ni6sEvbl7oRFGcR4PCp4DxbX0_BN6cMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/edit/index.vue")
  },
  {
    name: "admin_group_list",
    path: "list",
    meta: indexAWpd0RLmOu3_45y7bQ5Qkd_uIyZrbLI29EJrAKfT62l2AMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/list/index.vue")
  },
  {
    name: "admin_group_role",
    path: "role",
    meta: index9xZ3VG6eUPO_2IUrnJq63JM9Y7t5Bwald6_45comg2rBwMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/role/index.vue")
  },
  {
    name: "admin_group_view",
    path: "view",
    meta: indexWb2_fb20ZBIj6xcNXu8jh7RqeUID7LRN5cvtU9axT5wMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/view/index.vue")
  },
  {
    name: "admin_group_apply",
    path: "apply",
    meta: indexWUg4skSdFNKeIeRAFq5ive_MvmIApdwds9QAwMnQkQEMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/apply/index.vue")
  },
  {
    name: "admin_group_create",
    path: "create",
    meta: indexYywmR62ZKgVG6oRzc3godIisTFYDM8UJSuTqjKDxZYIMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/create/index.vue")
  },
  {
    name: "admin_group_member",
    path: "member",
    meta: index5P0_45HLINR_aeq3Y_45IGjZgLrkZAB2zZYmvc5GyFy4f5QMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/member/index.vue")
  },
  {
    name: "admin_group_submission",
    path: "submission",
    meta: indexy7SD4eIxcntWEU_455PzXq3W_zvw_45bgseiV_45N2Ac8mrNYMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/submission/index.vue")
  },
  {
    name: "admin_group_announcement",
    path: "announcement",
    meta: index_q5luKhJZJk1WlqFNrNofh6l0e38BIR_45NyGJtcet_45WwMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/announcement/index.vue")
  },
  {
    name: "admin_group_announcement_create",
    path: "announcement/create",
    meta: indexx9TNLjfusJ5AgiRlplz1nRpzhzMlLh6_45O0Xpu7Eie5UMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/group/announcement/create/index.vue")
  }
]
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexGKmOffu0sv_4jb4miqmSwL9iOImgIXHDyLGCl8wdcusMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/index.vue")
  },
  {
    name: "admin-contest",
    path: "/admin/contest",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest.vue"),
    children: [
  {
    name: "admin_contest_edit",
    path: "edit",
    meta: indexoubvzYuf3BepWRsa_REVI3DX_E_45KqeS2P_yMm_45c5n_oMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest/edit/index.vue")
  },
  {
    name: "admin_contest_list",
    path: "list",
    meta: indexmW_45duvlfoBnVzTVypZkkjxP3WgMDPQZ4Co1FcALHsQoMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest/list/index.vue")
  },
  {
    name: "admin_contest_view",
    path: "view",
    meta: indexT_45T3VhLVmvYAMsmnnGhwvqJ653t5NkjjzKoi6wjWE_45sMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest/view/index.vue")
  },
  {
    name: "admin_contest_score",
    path: "score",
    meta: indexXKDK2ZshiBtB1YVDZ_s9Vv0CbQSbem77Ml0ip6z2z4MMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest/score/index.vue")
  },
  {
    name: "admin_contest_create",
    path: "create",
    meta: indexkA80_45qf0MBpzb4leH9PvQ8egGOGEObHVvchGjkt7m7UMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest/create/index.vue")
  },
  {
    name: "admin_contest_problem",
    path: "problem",
    meta: indexAwx_OP0BeT9dRZ1QDDyFELKkAbmCy_hDZmfcKlYIlnYMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest/problem/index.vue")
  },
  {
    name: "admin_contest_submissions",
    path: "submissions",
    meta: indexPIV3PhYGQnV67tZmZI5Ou_i_fu9QF3ygp1wnhqFBy5cMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest/submissions/index.vue")
  },
  {
    name: "admin_contest_announcement",
    path: "announcement",
    meta: index_9Al_45TseJQxbHOlAAk_45SRxSs8DF03tdgMMX1ODZ_LGUMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest/announcement/index.vue")
  },
  {
    name: "admin_contest_announcement_create",
    path: "announcement/create",
    meta: index_10ja0fnoVu8oBX0tD53f6rPD7qqvAOsb5M0AbPcBmcMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest/announcement/create/index.vue")
  }
]
  },
  {
    name: "admin-problem",
    path: "/admin/problem",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem.vue"),
    children: [
  {
    name: "admin_problem_list",
    path: "list",
    meta: indexw4KzG8S3d1fcQwvK6eua99w_45HIiA9CIRG8lw1BkcXCYMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem/list/index.vue")
  },
  {
    name: "admin_problem_edit_oj",
    path: "edit/oj",
    meta: indexqMlhXvWRcIcMyC8BkMEqTN34LS_45LMB77DYbv0ALYYZYMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem/edit/oj/index.vue")
  },
  {
    name: "admin_problem_view_oj",
    path: "view/oj",
    meta: indexLwLrlWi1hvDso14Zwn7WtLd_i_sIdd5dOMSWwXcX12IMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem/view/oj/index.vue")
  },
  {
    name: "admin_problem_solution",
    path: "solution",
    meta: index35b9_45AzUqrP54KojpbW_mFoKIpzsbev3JHVwI1VHEQMMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem/solution/index.vue")
  },
  {
    name: "admin_problem_create_oj",
    path: "create/oj",
    meta: indexNC_sVSyiymx3elTd31VsVHgW9eUys5owKeVMDh6ykIkMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem/create/oj/index.vue")
  },
  {
    name: "admin_problem_edit_objective",
    path: "edit/objective",
    meta: indexwGjI6CGevWAnGw2KyAbOSsaH_45chRP1DkI_45D46bxB_45L8Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem/edit/objective/index.vue")
  },
  {
    name: "admin_problem_view_objective",
    path: "view/objective",
    meta: indexeXY6pT3j_tEOSkdH4jRYouycF_45oWxTer4Ykjv7G6tzAMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem/view/objective/index.vue")
  },
  {
    name: "admin_problem_solution_create",
    path: "solution/create",
    meta: indexk3aY5up7Z2PwWmOS5cu7QuRt9IJiunOreFrF02qTshEMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem/solution/create/index.vue")
  },
  {
    name: "admin_problem_create_objective",
    path: "create/objective",
    meta: indexh79on8P_45SJbbmw9aJ3ITOwGKjMKkmT6gXpoCdLaMr0QMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/problem/create/objective/index.vue")
  }
]
  },
  {
    name: "oj_task",
    path: "/oj/task",
    meta: indexu7R_456SqXNiLp8kfi9_8O9_cCFydv4mNYtJiTs1jPKdEMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/task/index.vue")
  },
  {
    name: "admin-training",
    path: "/admin/training",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/training.vue"),
    children: [
  {
    name: "admin_training_edit",
    path: "edit",
    meta: indexEQBzZ1XFUC2xG148gXCaKXBjdeifRqwWhJB919a89p0Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/training/edit/index.vue")
  },
  {
    name: "admin_training_list",
    path: "list",
    meta: indexmGfRqhxkwVgwh6VPIM26_45oI5H6V2WIcBDcl14E80OiIMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/training/list/index.vue")
  },
  {
    name: "admin_training_view",
    path: "view",
    meta: index6tUqjx6ziYWRkaKHxvQeh0FG1EmJKqgZB5es7o6SfC8Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/training/view/index.vue")
  },
  {
    name: "admin_training_create",
    path: "create",
    meta: index98eNPjPuuVXoyDY2D_qMuOHp9uvgDtVo7pWzlLg98sAMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/training/create/index.vue")
  },
  {
    name: "admin_training_status",
    path: "status",
    meta: indexg7PYF3Wo4ObruCdVF7f5qupXEBBUDaSnoomvRaBHscsMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/training/status/index.vue")
  },
  {
    name: "admin_training_problem",
    path: "problem",
    meta: indexgDy1DGxHdADKrweCDBxRfVUhvLfK1H3L9Aby855WGJwMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/training/problem/index.vue")
  },
  {
    name: "admin_training_submissions",
    path: "submissions",
    meta: indexrvQifHpTdh5jfFAkK6ciN4CT3kfEGuoqJMWx7xTdzp0Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/training/submissions/index.vue")
  }
]
  },
  {
    name: "oj_guide",
    path: "/oj/guide",
    meta: indexjS08joancDKP7rMBxV6FzdyJ6LlVTYhXY3KVTpipXdgMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/guide/index.vue")
  },
  {
    name: "admin-community",
    path: "/admin/community",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/community.vue"),
    children: [
  {
    name: "admin_community_post",
    path: "post",
    meta: indexV55Ic1tLcgllQMbQl9nn7nqIanT_zi2L_45cOcHlnWJeUMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/community/post/index.vue")
  },
  {
    name: "admin_community_solution",
    path: "solution",
    meta: indexswMM9PiL79BlRyOF_45Mxt_ob_yfNS_RBzxX2AZCCUeVwMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/community/solution/index.vue")
  },
  {
    name: "admin_community_post_comment",
    path: "post/comment",
    meta: indexBRZi7YgHnyWfBPFhHIrAFTUxTs1Dk97uaoUqvgvKGy0Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/community/post/comment/index.vue")
  },
  {
    name: "admin_community_problem_comment",
    path: "problem/comment",
    meta: indexnHWKDlwNybmORqg_bRDe0QrzMuMZD1Wx3vLO0H3tNnQMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/community/problem/comment/index.vue")
  },
  {
    name: "admin_community_solution_comment",
    path: "solution/comment",
    meta: indexEEYHMbcXRB_45ZLXNatJlny9y9_450pNJ5fA5sK11V_451OZcMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/community/solution/comment/index.vue")
  },
  {
    name: "admin_community_post_comment_applications",
    path: "post/applications",
    meta: indexFeg4CC2LDupC2zY6SoE98C2_uPVhGoyr3hspA8SePmsMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/community/post/applications/index.vue")
  }
]
  },
  {
    name: "admin-warehouse",
    path: "/admin/warehouse",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/warehouse.vue"),
    children: [
  {
    name: "admin_warehouse_edit",
    path: "edit",
    meta: indexdSN7FnGao8wKIG5xBOqMvrS0a9bNYtYjkLh7PHLN6N4Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/warehouse/edit/index.vue")
  },
  {
    name: "admin_warehouse_list",
    path: "list",
    meta: indexFlRwthJHTXg_4550TEzLLvG6Y_UsqTjnsy2ciEqazllRgMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/warehouse/list/index.vue")
  },
  {
    name: "admin_warehouse_view",
    path: "view",
    meta: index1Ueu5gY5_45HnWD8S2Brd1wPKUOkg46Z98kA_45W51tBElkMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/warehouse/view/index.vue")
  },
  {
    name: "admin_warehouse_create",
    path: "create",
    meta: index_453A47Z4_GYQYLH8WDmTQdCxCA6xVIQo8SoIc7rBAbMMMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/warehouse/create/index.vue")
  },
  {
    name: "admin_warehouse_import",
    path: "import",
    meta: indexf1j1YfO3w5aS3xwrlZ9kKiNjdm2vHkgAI57PtNt00SsMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/warehouse/import/index.vue")
  },
  {
    name: "admin_warehouse_problem",
    path: "problem",
    meta: indexMUzQH9h8x5OZKoykgKVct6PcCu_p8MRX_z3zBP0Um6EMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/warehouse/problem/index.vue")
  },
  {
    name: "admin_warehouse_import_whitelist",
    path: "import/whitelist",
    meta: indexzZosiUxxSP48w7nwfYwhya3aoWHco7InxWxwrzNGYtcMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/warehouse/import/whitelist/index.vue")
  }
]
  },
  {
    name: "oj_galaxy",
    path: "/oj/galaxy",
    meta: indexhLSk3HQste3Bkr6S4Ce6rGKQ3_45zygQxb4KG8HhnR0tMMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/galaxy/index.vue")
  },
  {
    name: "oj_notice",
    path: "/oj/notice",
    meta: index_45sAoIutyVcQPLJtM1z4HO7GbF4F3Yy276htC42ROa4EMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/notice/index.vue")
  },
  {
    name: "discuss-category",
    path: "/discuss/category",
    meta: categoryErheMEtjkJhhpqa3T7pfhc_45oF6mVmZ3wlIpO4idY6k4Meta || {},
    redirect: {"name":"discuss_category_academic"},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/discuss/category.vue"),
    children: [
  {
    name: "discuss_category_general",
    path: "general",
    meta: indexOaBPirKE2Z9ZpWKYmTYvfBhFXk0qpFz17i5QN3a7dwEMeta || {},
    redirect: {"name":"index"},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/discuss/category/general/index.vue")
  },
  {
    name: "discuss_category_academic",
    path: "academic",
    meta: indexHOr3cw3DN_45pC_4U9PJUBysVbIMYxxV7NA_b5HF_45u3Y0Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/discuss/category/academic/index.vue")
  }
]
  },
  {
    name: "im_student",
    path: "/im/student",
    meta: index2JhQl5mcn1zSc9YIcdCAsdnThJsXJQghgcgQWVJxxSAMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/im/student/index.vue")
  },
  {
    name: "im_teacher",
    path: "/im/teacher",
    meta: indexFCaMET_45ArM25_JKB_L5Dy_45dEji8UQfcJuTW7WpzwF18Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/im/teacher/index.vue")
  },
  {
    name: "oj_article",
    path: "/oj/article",
    meta: index60PZu7l7OA676uGPm5lllqZOtdkZrdSw0o4y2sQW_45xwMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/article/index.vue")
  },
  {
    name: "oj_contest",
    path: "/oj/contest",
    meta: indexDXrR_oAI47pZJrfrP_axq5iv_459mF7XYwYuuLyDLqgh0Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/contest/index.vue")
  },
  {
    name: "oj_problem",
    path: "/oj/problem",
    meta: indexNXP7cHQfmY_45SLExurIqZt7lCpqAu93L66rQEXJfNVSEMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/problem/index.vue")
  },
  {
    name: "oj_ranking",
    path: "/oj/ranking",
    meta: index6sADbCsWawNt5YSjo_45OctYJc6yIETpDJ6Uba_aNXyfIMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/ranking/index.vue")
  },
  {
    name: "admin-indexconfig",
    path: "/admin/indexconfig",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/indexconfig.vue"),
    children: [
  {
    name: "admin_indexconfig_banner",
    path: "banner",
    meta: index9s91GAzGWsaVbb_mCVQxZNx3QXrPa1pN5PGEB9LjBC8Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/indexconfig/banner/index.vue")
  },
  {
    name: "admin_indexconfig_article",
    path: "article",
    meta: indexKYDWgrsaipUXHME0s8mdJD4FHWm6_45TIHBT5tSTt3aS0Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/indexconfig/article/index.vue")
  },
  {
    name: "admin_indexconfig_contest",
    path: "contest",
    meta: indexzVBpKWvLYNc1EPPj337ti2d0UAByJdvlVfU0H8VyYVsMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/indexconfig/contest/index.vue")
  },
  {
    name: "admin_indexconfig_banner_create",
    path: "banner/create",
    meta: indexBnH_dXGIzjsUqc5xFmxLA_45bdpsokhni6zLhAojzmW7wMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/indexconfig/banner/create/index.vue")
  },
  {
    name: "admin_indexconfig_article_create",
    path: "article/create",
    meta: index8AvMp3SUsATNatqJbzl6_45_ujxl_45VjiCILyINh4eEyg4Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/indexconfig/article/create/index.vue")
  }
]
  },
  {
    name: "oj_backpack",
    path: "/oj/backpack",
    meta: indexhPSFX5dFup_aOgsdf_45JTeFFUfam7xvt_45W0QjnvUp__45cMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/backpack/index.vue")
  },
  {
    name: detailCOxCz6QAsFDXsH7e7MxO_lUTLQUg4il3W3Nt_KnfiDcMeta?.name,
    path: "/oj/contest/detail",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/contest/detail.vue"),
    children: [
  {
    name: "oj_contest_detail",
    path: "",
    meta: indexIRgrY8U41XeOx7NNCNDINXfh1xT0uqbYW0boZ85_45N_45QMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/contest/detail/index.vue")
  },
  {
    name: "oj_contest_detail_score",
    path: "score",
    meta: indexHl565v0Br7OY5s9gLrUVMBRIFZ96_SXjktr_2uolBFoMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/contest/detail/score/index.vue")
  },
  {
    name: "oj_contest_detail_notice",
    path: "notice",
    meta: index6eC7brBsAkNqbaG0zj6_qEiXSa9gXsGTQ_TDhb4IChoMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/contest/detail/notice/index.vue")
  },
  {
    name: "oj_contest_detail_problem",
    path: "problem",
    meta: indexoJr2tvToRcFdbi6JLP_8iRW2pMVfpRwq937vK9pzIBwMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/contest/detail/problem/index.vue")
  }
]
  },
  {
    name: "oj_training",
    path: "/oj/training",
    meta: index0UdhTszsQFZeIw5diKMNdZmQydIGxO3GWvG7iH9fRxkMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/training/index.vue")
  },
  {
    name: "admin_contest_code",
    path: "/admin/contest-code",
    meta: contest_45codeBPLVM_45bS5da2n_A3SgJk5z44vs6hRtbIOwQV0_yViPkMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/contest-code.vue")
  },
  {
    name: "callback_crm",
    path: "/callback/crm",
    meta: indexdhKtM33yOFgmi7nb9mE78bf7LpnoMrjAbEV2N9FJKZcMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/callback/crm/index.vue")
  },
  {
    name: detailVTZE9nxB2BGQEXB4jybE16yLjU6UarjXL21l5WtEk5MMeta?.name,
    path: "/oj/training/detail",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/training/detail.vue"),
    children: [
  {
    name: "oj_training_detail",
    path: "",
    meta: indexkoZ3LqPdJL96yJaF3pH6fe3aMmR7p8SVQmQATq1ee6oMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/training/detail/index.vue")
  },
  {
    name: "oj_training_detail_problem",
    path: "problem",
    meta: indexnT57PfIJUa2Q_csq1IY5Js_45MwSToyMkl_45acNYf69o7MMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/training/detail/problem/index.vue")
  }
]
  },
  {
    name: "callback_code",
    path: "/callback/code",
    meta: indexkAQ5f4NFqqGqPRqdKLBTcKF12_yBs2ZsW49lG2bout8Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/callback/code/index.vue")
  },
  {
    name: "callback_group",
    path: "/callback/group",
    meta: indexnc2JPz8zy7566jbK1HL0RDKgJjrxrUloKdbg7pmoPy0Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/callback/group/index.vue")
  },
  {
    name: "callback_feishu",
    path: "/callback/feishu",
    meta: indexqNu9M1GInAO3lPSFK8Y9kmh0Dbt4PrMnsnCupjB7KcAMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/callback/feishu/index.vue")
  },
  {
    name: "callback_wechat",
    path: "/callback/wechat",
    meta: indexzcmPbuzBydW_45ZbUxiYVAoig5SZdtCwH2_455VptJI0ATsMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/callback/wechat/index.vue")
  },
  {
    name: "oj_announcement_detail",
    path: "/oj/announcement",
    meta: index2pm__jmhMYbGNjxFJ6mA54GmpQkHHpi4RBPyMbJmzoYMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/announcement/index.vue")
  },
  {
    name: "admin-incentive-reward",
    path: "/admin/incentive/reward",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/reward.vue"),
    children: [
  {
    name: "admin_incentive_reward_badge",
    path: "badge",
    meta: indexJRZwf6or81HhRkmzxpBV5lOWjlJADoEc3ZflylBle3AMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/reward/badge/index.vue")
  },
  {
    name: "admin_incentive_reward_avatarframe",
    path: "avatarframe",
    meta: indexMjZbRC738C6nwn65ujThAvuNDUovsGBNLiCRpU4beG0Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/reward/avatarframe/index.vue")
  },
  {
    name: "admin_incentive_reward_cursortrails",
    path: "cursortrails",
    meta: indexIFV7ban4KcND_45Pe_Y8mza9yFuKSIHz4di8jbY4n_VjQMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/reward/cursortrails/index.vue")
  },
  {
    name: "admin_incentive_reward_homebackground",
    path: "homebackground",
    meta: index0vv7_LpfNj0wHjvnrDhYvB7Kb6mhH31CIMyrmSEuck8Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/reward/homebackground/index.vue")
  },
  {
    name: "admin_incentive_reward_gradedecoration",
    path: "gradedecoration",
    meta: index4x6G0NcJzTSNsdHY7I34Xx9Ejbnadub1iSRrYJuL3_45cMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/reward/gradedecoration/index.vue")
  }
]
  },
  {
    name: "admin_submission",
    path: "/admin/submission",
    meta: indexe3T1WM4eK6EBR60vBt_M5RRt6jqIkSpxaZqGxpG5tqsMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/submission/index.vue")
  },
  {
    name: "oj_entrance_exam",
    path: "/oj/entrance-exam",
    meta: indexewpyKkyZxY_45HUptduJNiDExACFVWF6Iv0oRhZISd82IMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/entrance-exam/index.vue")
  },
  {
    name: "oj_galaxy_report",
    path: "/oj/galaxy/report",
    meta: indexQngqVS5cvtT7pCMCKNnmgDMxc_3GhUx0qcF41ymH64sMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/galaxy/report/index.vue")
  },
  {
    name: "admin-incentive-mission",
    path: "/admin/incentive/mission",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission.vue"),
    children: [
  {
    name: "admin_incentive_mission_edit",
    path: "edit",
    meta: indexfh9Au3IE8gupocvdl1tpFk_CKTazC8eDfXZcBcwzjSkMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission/edit/index.vue")
  },
  {
    name: "admin_incentive_mission_view",
    path: "view",
    meta: indexibGgxqYOLySj2Mqg4ZNd1B8uh_QojfXLu6bms_E1R3AMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission/view/index.vue")
  },
  {
    name: "admin_incentive_mission_goods",
    path: "goods",
    meta: indexcvHrrvpdJdmfxqCBgFSEGSkPXTN1FGC6ZHu415j0gh0Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission/goods/index.vue")
  },
  {
    name: "admin_incentive_mission_medal",
    path: "medal",
    meta: indexukCBgVZvMy2EyXyX2nyiodLHAazb_45UP3XYsf4mo9C38Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission/medal/index.vue")
  },
  {
    name: "admin_incentive_mission_battle",
    path: "battle",
    meta: indexZtcCiuXGf7Ayg_7k7OxY7SkzCaucEJYMlt1ck5L0XlcMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission/battle/index.vue")
  },
  {
    name: "admin_incentive_mission_create",
    path: "create",
    meta: indexcnQmFKnlIDydrnx3k5rxemt22hpHmkNWs15Wf9zdHHEMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission/create/index.vue")
  },
  {
    name: "admin_incentive_mission_manual",
    path: "manual",
    meta: indexhfwa2BwXwWOf9aop1AbSslwO5ztiHri5fOd4UeIYN2cMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission/manual/index.vue")
  },
  {
    name: "admin_incentive_mission_normal",
    path: "normal",
    meta: indexxFOlIfbJjHilVTc_HnXz2T3MWJFimRg8Hni3sPg5QA0Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission/normal/index.vue")
  },
  {
    name: "admin_incentive_mission_random",
    path: "random",
    meta: indexAlqrjj7YYjhyIW3nc_gQSROYRFRQLBMoa_dYdqyW5TgMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/mission/random/index.vue")
  }
]
  },
  {
    name: "discuss_post_edit",
    path: "/discuss/post/edit",
    meta: indexsHnBXb0ABWRHEvu0sV5ZIotV9Rs20NY6ZMm1ogMEwQsMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/discuss/post/edit/index.vue")
  },
  {
    name: "oj_article_detail",
    path: "/oj/article/detail",
    meta: indexNhyGVu0Pa7xnXY5Vmn9eGykYvduLqljF9cPidXj_eBIMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/article/detail/index.vue")
  },
  {
    name: "oj_galaxy_problem",
    path: "/oj/galaxy/problem",
    meta: indexpIZJHKnlc16_wgaCz_T_gR0GMWO9GAtif8XpjBbhjqkMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/galaxy/problem/index.vue")
  },
  {
    name: "oj_problem_detail",
    path: "/oj/problem/detail",
    meta: indexOLhYnoqYWGTD6hZdQTx6B4_Qd10TWXKjpSpcLJsLWaEMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/problem/detail/index.vue")
  },
  {
    name: "admin_clouddesktop",
    path: "/admin/clouddesktop",
    meta: indexgSziubV_ydjgR7Q5p64BQF2Easj05hZMZZ_45gC9VNmDAMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/clouddesktop/index.vue")
  },
  {
    name: "oj_activity_zongzi",
    path: "/oj/activity/zongzi",
    meta: indexyaSvIBoe842m7XweVyMh8XnmkhSqRCAIYpAfkfBsafgMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/activity/zongzi/index.vue")
  },
  {
    name: "discuss_post_create",
    path: "/discuss/post/create",
    meta: index8PP26z8HgcG08kftB0qjIbuEE_gL7t0GrbHnGRJXE58Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/discuss/post/create/index.vue")
  },
  {
    name: "discuss_post_detail",
    path: "/discuss/post/detail",
    meta: indexh5K8Nz87IDYEOb0EacgQaoMeV_45MFDjCEeUuZgiKoY8AMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/discuss/post/detail/index.vue")
  },
  {
    name: "oj_activity_lantern",
    path: "/oj/activity/lantern",
    meta: indexDYrXIAB_45zQ8d5LumWLHNVybFaM7MhhFcg8afXuckT1sMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/activity/lantern/index.vue")
  },
  {
    name: "oj_galaxy_milestone",
    path: "/oj/galaxy/milestone",
    meta: index0YYChBSlPa6mSPG4usayFZkFV1SfNw6_1XCDVF3jLr0Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/galaxy/milestone/index.vue")
  },
  {
    name: "oj_problem_solution",
    path: "/oj/problem/solution",
    meta: indexuLhNbLTMh6kCd_oKHtDrWv7diBvkqUCZj6y3u5RN4XgMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/problem/solution/index.vue")
  },
  {
    name: "admin_incentive_level",
    path: "/admin/incentive/level",
    meta: indexWUwzB_cIlafr_AiPOPRnOEd3MwIZYnJEv_45g9ud7AIQsMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/admin/incentive/level/index.vue")
  },
  {
    name: "oj_activity_challenge",
    path: "/oj/activity/challenge",
    meta: index6_JwXkPQb_UAGfLQh_bg78rn9_84kHWTql_ISdAMH3MMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/activity/challenge/index.vue")
  },
  {
    name: "oj_problem_submit_list",
    path: "/oj/problem/submit/list",
    meta: indexHwxnDYouD2XJ2XWpQuRUltRHCJUxI60e2x5DsrK0JyoMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/problem/submit/list/index.vue")
  },
  {
    name: "oj_problem_solution_edit",
    path: "/oj/problem/solution/edit",
    meta: indexSAlNlc29pmvwrpFQbaSY3fo_lv_45jorWJD7cCyuAA9MAMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/problem/solution/edit/index.vue")
  },
  {
    name: "oj_problem_submit_result",
    path: "/oj/problem/submit/result",
    meta: indexGqPW5ca3lx8vKTdHpQ_45SORq0pFzrLnXtE5nPaKlO8S4Meta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/problem/submit/result/index.vue")
  },
  {
    name: "oj_activity_challenge_exam",
    path: "/oj/activity/challenge/exam",
    meta: indexlEhde16vjo08oC75eIDNTkfGkuZYdD6lnyU_45iwHVx_wMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/activity/challenge/exam/index.vue")
  },
  {
    name: "oj_problem_solution_create",
    path: "/oj/problem/solution/create",
    meta: indexEhn29bOtLH6rhccu28z8Q0M5bLvpXq19f9X6tX6xQ4AMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/problem/solution/create/index.vue")
  },
  {
    name: "oj_problem_solution_detail",
    path: "/oj/problem/solution/detail",
    meta: indexyeX4MQAYvdMMeonCUpUVwKjEriaRtgGiHi4Wm1p7PbsMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/problem/solution/detail/index.vue")
  },
  {
    name: "activity_simulation2025_rank",
    path: "/activity/simulation2025/rank",
    meta: indexsQNP4_45TD3MOOIr_JTZDssqC4X1OaJ7uJZQbJg3TdAkQMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/activity/simulation2025/rank/index.vue")
  },
  {
    name: "oj_activity_challenge_result",
    path: "/oj/activity/challenge/result",
    meta: indexHwbJAj_45fevpgxTQecmtfL6KZ1pqTRBnjG9CGDxod1wAMeta || {},
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/activity/challenge/result/index.vue")
  },
  {
    name: "oj-galaxy-milestone-MilestoneWrong",
    path: "/oj/galaxy/milestone/MilestoneWrong",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/galaxy/milestone/MilestoneWrong.vue")
  },
  {
    name: "oj-galaxy-milestone-MilestoneRecord",
    path: "/oj/galaxy/milestone/MilestoneRecord",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/galaxy/milestone/MilestoneRecord.vue")
  },
  {
    name: "oj-galaxy-utils-use-galaxy-mdown-transform",
    path: "/oj/galaxy/utils/use-galaxy-mdown-transform",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/galaxy/utils/use-galaxy-mdown-transform.ts")
  },
  {
    name: "oj-activity-challenge-exam-ChallengeExam.service",
    path: "/oj/activity/challenge/exam/ChallengeExam.service",
    component: () => import("/work/release/fe-oj-monorepo-hetao/packages/core/pages/oj/activity/challenge/exam/ChallengeExam.service.ts")
  },
  {
    name: component_45stubQDP5SU1qXbGoXNgEMQHfLV3apqBHBpOREyzHGJPreUkMeta?.name,
    path: "/oj",
    component: component_45stubQDP5SU1qXbGoXNgEMQHfLV3apqBHBpOREyzHGJPreUk
  },
  {
    name: component_45stubQDP5SU1qXbGoXNgEMQHfLV3apqBHBpOREyzHGJPreUkMeta?.name,
    path: "/discuss",
    component: component_45stubQDP5SU1qXbGoXNgEMQHfLV3apqBHBpOREyzHGJPreUk
  }
]